import * as types from './types';

export const getImportLogReport = model => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(beginFetchReport());

    MPWWebApi.postGenericInsertUpdate('ImportStudentLog', model)
      .then(response => {
        dispatch({
          type: types.IMPORTLOG_GET_REPORT,
          payload: response.data,
        });
        dispatch(endFetchReport());
      })
      .catch(error => {
        dispatch({
          type: types.IMPORTLOG_ERROR,
          payload: error,
        });
        dispatch(endFetchReport());
      });
  };
};

const beginFetchReport = () => {
  return {
    type: types.IMPORTLOG_BEGIN_FETCH_REPORT,
  };
};

const endFetchReport = () => {
  return {
    type: types.IMPORTLOG_END_FETCH_REPORT,
  };
};

export const clearReport = () => {
  return {
    type: types.IMPORTLOG_CLEAR,
  };
};



// WEBPACK FOOTER //
// ./src/pages/importlog/state/actions.js